<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaPromocaoAgente />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaPromocaoAgente from "../Components/Listagens/ListaPromocaoAgente.vue";
export default {
  name: "ListPromo",
  components: {
    ListaPromocaoAgente,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>